import { CssRoles } from '@common/constants';
import { UserNavigation, UserNavigationItem } from '@common/entities';

export const FscdNavigationItems: UserNavigationItem[] = [
  { text: 'Homepage', action: 'dashboard', icon: 'copy', url: '/dash' },
  // { text: 'Admin', action: 'admin', icon: 'eye', url: '/admin', roleAccess: [CssRoles.CSSAdmin] },
  { text: 'Change Password', action: 'changePassword', icon: 'key', keycloakOnly: false },
  { text: 'Sign out', action: 'signOut', icon: 'person' },
];

export const FscdNavigation: UserNavigation = {
  type: 'tertiary',
  text: 'Profile Name',
  menuItems: FscdNavigationItems,
  logoutUrl: '/',
};
